import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Project } from '../models/projects';

type SliceModel = Project;
const sliceName: string = 'projects';

const currRequests: Set<ModelId> = new Set;

export const fetchProject = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const projectAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const projectSlice = createSlice({
    name: sliceName,
    initialState: projectAdapter.getInitialState(),
    reducers: {
        addMany: projectAdapter.addMany,
        addOne: projectAdapter.addOne,
        updateMany: projectAdapter.updateMany,
        updateOne: projectAdapter.updateOne,
        upsertOne: projectAdapter.upsertOne,
        upsertMany: projectAdapter.upsertMany,
        removeOne: projectAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchProject.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                projectAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
